import { useInternalTelemetry } from './useInternalTelemetry';
export var useSetTelemetry = function useSetTelemetry() {
  var context = useInternalTelemetry();
  return context.setTelemetry;
};
//# sourceMappingURL=useSetTelemetry.js.map